import { FC, useEffect } from 'react';
import { useFundInvestmentContext } from 'context';
import RequestDocuments from 'pages/Documents/RequestDocumentsView';

const FundInvestmentDocuments: FC = () => {
  // Fund investments context
  const { fundInvestmentValuationAllocation } = useFundInvestmentContext();
  const { setShouldShowVersionFilter } = fundInvestmentValuationAllocation;

  // Version filter
  useEffect(() => {
    setShouldShowVersionFilter(false);
  }, [setShouldShowVersionFilter]);

  return <RequestDocuments showDocumentGenerationJobsTab={false} />;
};

export default FundInvestmentDocuments;
